import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {Product} from '../types';

export const getColumns = (onRecordClick?: (record: Product) => void) => [
    {
        title: I18n.get('Name'),
        width: '1fr',
        render: (item: Product) => onRecordClick ? (
            <span
                style={{color: 'var(--mantine-color-blue-6)', cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.name}
            </span>
        ) : <NavLink to={`/products/${item.id}`}>{item.name}</NavLink>,
    },
    {
        title: I18n.get('Link'),
        width: '1fr',
        render: (item: Product) => item.url,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: Product) => formatTimestamp(item.created),
    },
];

// Keep backward-compatible export for any remaining consumers
export const columns = getColumns();
